/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenMetadataFields } from './TokenMetadataFields';
import {
    TokenMetadataFieldsFromJSON,
    TokenMetadataFieldsFromJSONTyped,
    TokenMetadataFieldsToJSON,
} from './TokenMetadataFields';

/**
 * Configuration for OAuth2.0. Must be provided if authType is oauth2.
 * @export
 * @interface Oauth2Opts
 */
export interface Oauth2Opts {
    /**
     * 
     * @type {string}
     * @memberof Oauth2Opts
     */
    grantType: Oauth2OptsGrantTypeEnum;
    /**
     * The authorization URL.
     * @type {string}
     * @memberof Oauth2Opts
     */
    authURL?: string;
    /**
     * The token URL.
     * @type {string}
     * @memberof Oauth2Opts
     */
    tokenURL: string;
    /**
     * Whether scopes are required to be known ahead of the OAuth flow.
     * @type {boolean}
     * @memberof Oauth2Opts
     */
    explicitScopesRequired: boolean;
    /**
     * Whether the workspace is required to be known ahead of the OAuth flow.
     * @type {boolean}
     * @memberof Oauth2Opts
     */
    explicitWorkspaceRequired: boolean;
    /**
     * A list of URLs that represent the audience for the token, which is needed for some client credential grant flows.
     * @type {Array<string>}
     * @memberof Oauth2Opts
     */
    audience?: Array<string>;
    /**
     * 
     * @type {TokenMetadataFields}
     * @memberof Oauth2Opts
     */
    tokenMetadataFields: TokenMetadataFields;
    /**
     * URL with more information about where to retrieve Client ID and Client Secret, etc.
     * @type {string}
     * @memberof Oauth2Opts
     */
    docsURL?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Oauth2Opts
     */
    authURLParams?: { [key: string]: string; };
}


/**
 * @export
 */
export const Oauth2OptsGrantTypeEnum = {
    AuthorizationCode: 'authorizationCode',
    AuthorizationCodePkce: 'authorizationCodePKCE',
    ClientCredentials: 'clientCredentials',
    Password: 'password'
} as const;
export type Oauth2OptsGrantTypeEnum = typeof Oauth2OptsGrantTypeEnum[keyof typeof Oauth2OptsGrantTypeEnum];


/**
 * Check if a given object implements the Oauth2Opts interface.
 */
export function instanceOfOauth2Opts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "grantType" in value;
    isInstance = isInstance && "tokenURL" in value;
    isInstance = isInstance && "explicitScopesRequired" in value;
    isInstance = isInstance && "explicitWorkspaceRequired" in value;
    isInstance = isInstance && "tokenMetadataFields" in value;

    return isInstance;
}

export function Oauth2OptsFromJSON(json: any): Oauth2Opts {
    return Oauth2OptsFromJSONTyped(json, false);
}

export function Oauth2OptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Oauth2Opts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grantType': json['grantType'],
        'authURL': !exists(json, 'authURL') ? undefined : json['authURL'],
        'tokenURL': json['tokenURL'],
        'explicitScopesRequired': json['explicitScopesRequired'],
        'explicitWorkspaceRequired': json['explicitWorkspaceRequired'],
        'audience': !exists(json, 'audience') ? undefined : json['audience'],
        'tokenMetadataFields': TokenMetadataFieldsFromJSON(json['tokenMetadataFields']),
        'docsURL': !exists(json, 'docsURL') ? undefined : json['docsURL'],
        'authURLParams': !exists(json, 'authURLParams') ? undefined : json['authURLParams'],
    };
}

export function Oauth2OptsToJSON(value?: Oauth2Opts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'grantType': value.grantType,
        'authURL': value.authURL,
        'tokenURL': value.tokenURL,
        'explicitScopesRequired': value.explicitScopesRequired,
        'explicitWorkspaceRequired': value.explicitWorkspaceRequired,
        'audience': value.audience,
        'tokenMetadataFields': TokenMetadataFieldsToJSON(value.tokenMetadataFields),
        'docsURL': value.docsURL,
        'authURLParams': value.authURLParams,
    };
}

